/** @jsx jsx */
import { jsx } from 'theme-ui'
import { cf2imgix } from '../utils/cf2imgix'
import {
  APPLE_TV,
  NETFLIX,
  GIFF_GAFF,
  VODAPHONE,
  TALK_TALK,
  O2,
  VIRGIN_MEDIA,
  PLUSNET,
  BT,
  DISNEY_PLUS,
  THREE,
  TESCO_MOBILE,
  EE,
  SKY,
  SMARTY,
  COMMUNITY_FIBRE,
  HYPEROPTIC,
  MUSIC_MAGPIE,
  ID_MOBILE,
  PIXEL,
  AIRALO,
  LEBARA
} from './brands/brandImages'
import Marquee from 'react-fast-marquee'

const marqueeImages = [
  APPLE_TV,
  NETFLIX,
  GIFF_GAFF,
  VODAPHONE,
  MUSIC_MAGPIE,
  ID_MOBILE,
  LEBARA,
  PIXEL,
  AIRALO,
  VODAPHONE,
  TALK_TALK,
  O2,
  VIRGIN_MEDIA,
  PLUSNET,
  BT,
  DISNEY_PLUS,
  THREE,
  TESCO_MOBILE,
  EE,
  SKY,
  SMARTY,
  COMMUNITY_FIBRE,
  HYPEROPTIC
].map((url) => ({
  src: cf2imgix(url),
  alt: url.replace(/^\S*\//, '').replace(/\..*$/, ''),
  key: url
}))

const MarqueeImage = ({ src, alt }) => (
  <img sx={{ height: '36px', mx: [16, 36] }} alt={alt} src={src} />
)

const BrandsSection = () => (
  <div>
    <Marquee gradientWidth={0} speed={35}>
      {marqueeImages.map((marqueeImage) => (
        <MarqueeImage {...marqueeImage} />
      ))}
    </Marquee>
  </div>
)

export default BrandsSection
